import { useState, useEffect } from 'react';
import { api, endpoints } from '../config/api';
import { useAuth } from '../context/AuthContext';
import DataTable from '../components/DataTable';
import Modal from '../components/Modal';

function QuestionsPage() {
  const { token } = useAuth();
  const [questions, setQuestions] = useState([]);
  const [stations, setStations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({
    texto: '',
    tipo: 'simple',
    opciones: ['', '', '', ''],
    respuestaCorrecta: '',
    estacionId: '',
    speakerId: '',
    eventoId: '',
  });

  const load = async () => {
    try {
      const [q, s] = await Promise.all([
        api.get(endpoints.questions(), token),
        api.get(endpoints.stations(), token),
      ]);
      setQuestions(q);
      setStations(s);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const opciones = form.opciones.filter((o) => o?.trim());
      const payload = {
        texto: form.texto,
        tipo: form.tipo,
        opciones,
        respuestaCorrecta: form.tipo === 'multiple' ? [form.respuestaCorrecta] : form.respuestaCorrecta,
        estacionId: +form.estacionId,
        speakerId: form.speakerId ? +form.speakerId : null,
        eventoId: form.eventoId ? +form.eventoId : null,
      };
      if (editing) await api.put(endpoints.question(editing.id), payload, token);
      else await api.post(endpoints.questions(), payload, token);
      setModalOpen(false);
      setEditing(null);
      load();
    } catch (err) {
      alert(err?.message || 'Error');
    }
  };

  const handleDelete = async (row) => {
    if (!window.confirm('¿Eliminar pregunta?')) return;
    try {
      await api.delete(endpoints.question(row.id), token);
      load();
    } catch (err) {
      alert(err?.message || 'Error');
    }
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'texto', label: 'Pregunta', render: (v) => (v ? String(v).slice(0, 50) + '...' : '') },
    { key: 'tipo', label: 'Tipo' },
    { key: 'estacionId', label: 'Estación' },
  ];

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Preguntas</h1>
        <button onClick={() => { setEditing(null); setForm({ texto: '', tipo: 'simple', opciones: ['', '', '', ''], respuestaCorrecta: '', estacionId: '', speakerId: '', eventoId: '' }); setModalOpen(true); }} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Nueva pregunta</button>
      </div>
      {loading ? <p>Cargando...</p> : <DataTable columns={columns} data={questions} onEdit={(r) => { setEditing(r); setForm({ texto: r.texto, tipo: r.tipo || 'simple', opciones: [r.opcion1, r.opcion2, r.opcion3, r.opcion4].filter(Boolean) || ['', '', '', ''], respuestaCorrecta: r.respuestaCorrecta_valor || '', estacionId: r.estacionId, speakerId: r.speakerId || '', eventoId: r.eventoId || '' }); setModalOpen(true); }} onDelete={handleDelete} />}
      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} title={editing ? 'Editar pregunta' : 'Nueva pregunta'}>
        <form onSubmit={handleSave} className="space-y-4">
          <div><label className="block text-sm font-medium mb-1">Texto</label><textarea value={form.texto} onChange={(e) => setForm((f) => ({ ...f, texto: e.target.value }))} className="w-full px-3 py-2 border rounded" rows={3} required /></div>
          <div><label className="block text-sm font-medium mb-1">Tipo</label><select value={form.tipo} onChange={(e) => setForm((f) => ({ ...f, tipo: e.target.value }))} className="w-full px-3 py-2 border rounded"><option value="simple">Simple</option><option value="multiple">Múltiple</option></select></div>
          <div><label className="block text-sm font-medium mb-1">Estación</label><select value={form.estacionId} onChange={(e) => setForm((f) => ({ ...f, estacionId: e.target.value }))} className="w-full px-3 py-2 border rounded" required>{stations.map((s) => <option key={s.id} value={s.id}>{s.nombre}</option>)}</select></div>
          <div><label className="block text-sm font-medium mb-1">Opciones (una por línea)</label>{[0, 1, 2, 3].map((i) => <input key={i} value={form.opciones[i] || ''} onChange={(e) => { const o = [...form.opciones]; o[i] = e.target.value; setForm((f) => ({ ...f, opciones: o })); }} className="w-full px-3 py-2 border rounded mb-2" placeholder={`Opción ${i + 1}`} />)}</div>
          <div><label className="block text-sm font-medium mb-1">Respuesta correcta (índice 0-3)</label><input type="number" min={0} max={3} value={form.respuestaCorrecta} onChange={(e) => setForm((f) => ({ ...f, respuestaCorrecta: e.target.value }))} className="w-full px-3 py-2 border rounded" /></div>
          <div className="flex gap-2 justify-end">
            <button type="button" onClick={() => setModalOpen(false)} className="px-4 py-2 border rounded">Cancelar</button>
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Guardar</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}

export default QuestionsPage;
